import { screenSize } from '@app/styles';
import styled from 'styled-components';
// import { inputBorderColor, screenSize, whiteColor } from '@app/styles';

export const UserRoleFormHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormHeading = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #0f123f;
  display: flex;
  align-items: center;
`;

export const ErrorMessage = styled.div`
  color: red;
`;
export const ButtonComponent = styled.div`
  display: flex;
`;

export const Container = styled.div`
  padding: 40px 24px;
`;

export const SaveButton = styled.div`
  margin-left: 4px;
`;

export const Seperator = styled.div`
  border: 1px solid #cbd5e0;
  margin: 24px 0px;
`;

export const RoleDetails = styled.div``;

export const UserRoleStatus = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0px 5px;
  @media (${screenSize.tablet}) {
    width: 50%;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  @media (${screenSize.tablet}) {
    flex-direction: row;
  }
`;
export const AddUserType = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  @media (${screenSize.tablet}) {
    flex-direction: row;
  }
`;

export const RoleName = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 50%;
  }
`;

export const Label = styled.label`
  color: #0f1d2a;
  opacity: 0.5;
`;

export const Description = styled.div`
  max-width: 660px;
`;
export const UserPermissionText = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #0f123f;
  margin: 16px 0px;
`;

export const Section = styled.div`
  border: 1px solid #e2e8f0;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  max-width: 660px;
`;

export const MunicipalitySection = styled.div``;

export const TransactionSection = styled.div``;

export const SectionHeader = styled.div`
  display: flex;
`;

export const HeaderText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3c8ec5;
`;

export const ChildText = styled.div`
  color: #4a5568;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 320px);
  }
`;
export const RoleProperty = styled.div``;

export const SectionChild = styled.div`
  background: #edeff3;
  border-radius: 8px;
  display: flex;
  padding: 10px;
  margin: 0px 0px 8px 24px;
`;
export const SectionSelect = styled.div`
  margin: 0px 0px 8px 24px;
`;
